import { IUserAuth } from "./userAuth.types"
import { Role } from "@/services/PermissionsService"

export class UserAuth implements IUserAuth {
  environment: string
  homeAccountId: string
  localAccountId: string
  tenantId: string
  username: string
  name: string
  roles: Role[]
  aud?: string
  exp?: number
  oid?: string

  constructor(data: {
    environment: string
    homeAccountId: string
    localAccountId: string
    tenantId: string
    username: string
    name: string
    roles: Role[]
    aud?: string
    exp?: number
    oid?: string
  }) {
    this.environment = data.environment
    this.homeAccountId = data.homeAccountId
    this.localAccountId = data.localAccountId
    this.tenantId = data.tenantId
    this.username = data.username
    this.name = data.name
    this.aud = data.aud
    this.exp = data.exp
    this.oid = data.oid
    this.roles = data.roles
  }
}
